import {useState} from "react";
import {FieldValues, SubmitHandler} from "react-hook-form";
import {getStateFromLocalStorage} from "@/app/[locale]/common/utils/functions/getStateFromLocalStorage/getStateFromLocalStorage";
import {getAllProjects} from "@/app/[locale]/common/utils/functions/getAllProjects/getAllProjects";
import {ACCESS_TOKEN_LOCAL_STORAGE_KEY, GENERAL_URL} from "@/app/[locale]/common/constants/app";

export const useCreateProject = (currentPage: number) => {
    const [ projectStatus, setProjectStatus ] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
    const [ error, setError ] = useState<null | string>(null);

    const createProject: SubmitHandler<FieldValues> = async (data) => {
        setProjectStatus('sending');
        const token = getStateFromLocalStorage(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        try {
            const res = await fetch(`${GENERAL_URL}/projects`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Content-Length': 'calculated when request is sent',
                    'Authorization': `Bearer ${token.accessToken}`,
                },
                body: JSON.stringify(data),
            });

            const response = await res.json();
            if (response.title) {
                await getAllProjects(currentPage);
                setProjectStatus('success');
            } else {
                setProjectStatus('error');
                if (response.error) setError(response.error);
            }
        } catch (err) {
            setProjectStatus('error');
            console.log(err);
        }
    };

    return {
        projectStatus,
        createProject,
        error,
    };
};